/**
 * Convert date to france order(YYYY-MM-DD,hh:mm,tz to DD/MM/YYYY)
 *
 * @param {string} dateWithTimeZoneString Full date with time zone
 * @return {string} converted date string
 */
export const convertDateToFranceOrder = (dateWithTimeZoneString: string) =>
    new Date(dateWithTimeZoneString).toLocaleDateString('fr-FR');
